import { render, staticRenderFns } from "./cg-misc-navigation.vue?vue&type=template&id=48f9c494&scoped=true"
import script from "./cg-misc-navigation.vue?vue&type=script&lang=js"
export * from "./cg-misc-navigation.vue?vue&type=script&lang=js"
import style0 from "./cg-misc-navigation.vue?vue&type=style&index=0&id=48f9c494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9c494",
  null
  
)

export default component.exports